import React, { RefObject, forwardRef } from 'react';
import { DeepTagsFilters, DeepTagsFiltersConfigProps, FormApiRef } from 'src/components-bl';
import { useFiltersManagement } from './hooks';
import { LoadingContainer, SkeletonStyled } from './AugSearch.styles';
import { AugmentedSearchFiltersSectionHeader } from './AugmentedSearchFiltersSectionHeader';
import { ContainerComponentProps } from './augmented-search-filters.types';

export const AugmentedSearchDeepTagFiltersContainer = forwardRef<
  FormApiRef,
  ContainerComponentProps
>(({ permittedRouteMap, ...props }, ref) => {
  const { filterProps } = useFiltersManagement({
    ...props,
    ref: ref as RefObject<FormApiRef>,
    permittedRouteMap,
  });

  return (
    <>
      {filterProps ? (
        <>
          <AugmentedSearchFiltersSectionHeader title={permittedRouteMap.deepTags?.title} />
          <DeepTagsFilters {...(filterProps as DeepTagsFiltersConfigProps)} />
        </>
      ) : (
        <LoadingContainer>
          <SkeletonStyled height={40} width={150} variant='rounded' />
          <SkeletonStyled height={100} variant='rounded' />
          <SkeletonStyled height={100} variant='rounded' />
        </LoadingContainer>
      )}
    </>
  );
});
